export { default } from "./LineClamp";
export type { LineClampProps } from "./LineClamp";
